export const ACCESS_TOKEN_V1_MEDIA_TYPE = 'application/vnd.io.idaas.api.access.token.v1+json';

export interface AccessToken {
  access_token: string;
  token_type: string;
  expires_in: number;
}

/**
 * Format an access token for the Authorization header of a HTTP request.
 *
 * @example
 * [HttpHeader.Authorization]: Bearer(accessToken)
 *
 * @param accessToken The access token to stringify
 * @returns A string of the form 'Bearer {innerToken}'
 */
export function Bearer(accessToken: AccessToken): string {
  if (!accessToken) {
    return undefined;
  }
  return `Bearer ${accessToken.access_token}`;
}
